<template>
  <div :class="'vp-multiselect-' + uniqueKey" class="vp-pos-relative">
    <span
      v-if="showLabel"
      :class="{
        invisible: !title || !value,
        'vp-pl-24 vp-ml-14': showPlaceholderIcon,
      }"
      class="multiselect-title vp-font-weight-700 vp-font-size-12 vp-pos-absolute vp-left-13 vp-ml-12 vp-top-10 vp-color-blue-1"
      style="z-index: 3"
      >{{ title }}</span
    >

    <svg
      v-if="showPlaceholderIcon"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="placeholder-icon"
    >
      <path
        d="M13.7467 15C14.0674 15 14.3884 14.8777 14.6329 14.6328C15.1224 14.1435 15.1224 13.3498 14.6329 12.8603L11.586 9.8135C13.2154 7.3595 12.9497 4.00983 10.7883 1.8485C8.32362 -0.616167 4.31323 -0.616167 1.84853 1.8485C-0.616175 4.31317 -0.616175 8.3235 1.84853 10.7883C3.08088 12.0207 4.69973 12.6368 6.31842 12.6368C7.53877 12.6368 8.75879 12.2863 9.81364 11.586L12.8605 14.6328C13.105 14.8777 13.4259 15 13.7467 15ZM3.40305 9.23367C1.79569 7.62633 1.79569 5.01083 3.40305 3.4035C4.20673 2.59983 5.26257 2.19783 6.31825 2.19783C7.37394 2.19783 8.42978 2.59967 9.23363 3.4035C10.841 5.01083 10.841 7.62633 9.23363 9.23367C7.62611 10.841 5.01057 10.841 3.40305 9.23367Z"
        fill="#787878"
      />
    </svg>

    <Multiselect
      :class="{
        [`multiselect-${uniqueKey}`]: true,
        'multiselect-error': errMsg,
      }"
      :value="value"
      @input="handleEmit"
      :options="options"
      :placeholder="placeholder || title"
      :maxHeight="maxHeight"
      :show-labels="showLabels"
      :allowEmpty="allowEmpty"
      :label="label"
      :track-by="trackBy"
      :selectLabel="selectLabel"
      :deselectLabel="deselectLabel"
      :disabled="disabled"
      :showNoResults="showNoResults"
      :showNoOptions="showNoOptions"
      :openDirection="openDirection"
      :multiple="multiple"
      :taggable="taggable"
      :tagPlaceholder="$t('common.tagPlaceholder')"
      @open="toggleLabel(), dropdownOpened(), $emit('open')"
      @close="toggleLabel(), dropdownClosed(), $emit('close')"
      @search-change="onSearchChange"
      @select="onSelect"
    >
      <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
      <span slot="noOptions">{{$t('common.emptList')}}</span>

    </Multiselect>

    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="wizard-spinner"
    />
    <div class="error-container" v-if="errMsg">
      <span v-if="errMsg" class="error">{{ errMsg }}</span>
    </div>
  </div>
</template>

<script>
import { randomStringMixin } from "@/utils/mixins/generateRandomStringMixin";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      uniqueKey: this.randomString(10),
      multiselectContainer: "",
      multiselect: "",
      multiselect_tags: "",
      multiselect_single: "",
      multiselect_placeholder: "",
      multiselect_input: "",
      multiselect_content_wrapper: "",
      multiselect_content_list: "",
      spinner: "",
      showLabel: null,
      isOpen: false,
    };
  },
  components: { Multiselect },
  mixins: [randomStringMixin],
  props: {
    value: {
      default: () => null,
    },
    noResultMessage: {
      type: String,
      // default: this.$t('common.noOptionAvailable'),
    },
    showOptionsBorder: {
      type: Boolean,
      default: false,
    },
    dropDownStyle: {
      type: String,
      default: "absolute",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showPlaceholderIcon: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    initialValue: {},
    errMsg: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    taggable:{
      type: Boolean,
      default: false
    },
    // placeholderSize: {
    //   type: String,
    //   default: "16" + "px",
    // },
    // placeholderFontWeight: {
    //   type: String,
    //   default: "400",
    // },
    // titleSize: {
    //   type: String,
    //   default: "13" + "px",
    // },
    // titleFontWeight: {
    //   type: String,
    //   default: "700",
    // },
    maxHeight: {
      type: Number,
      default: 300,
    },
    title: {
      type: String,
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    /* ------ Multiselect props ------ */
    // size:{   //#TODO: Add sizes : sm ,md ,lg

    // },
    trackBy: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "416",
    },
    zIndex: {
      type: String,
      default: "1",
    },
    height: {
      type: String,
      default: "55px",
    },
    backgroundColor: {
      type: String,
      default: "#f2f2f2",
    },

    allowEmpty: {
      type: Boolean,
      default: false,
    },
    openDirection: {
      // "above" "top" "below" "bottom"
      type: String,
      default: "bottom",
    },
    showNoOptions: {
      type: Boolean,
      default: true,
    },
    showNoResults: {
      type: Boolean,
      default: true,
    },
    /* ------ Input props ------ */
    // fontSize: {
    //   type: String,
    //   default: "16" + "px",
    // },
    // fontWeight: {
    //   type: String,
    //   default: "700",
    // },
    // fontColor: {
    //   type: String,
    //   default: "#000000de",
    // },

    /* ------ Label props ------ */
    label: {
      type: String,
      default: "",
    },
    // labelFontSize: {
    //   type: String,
    //   default: "12" + "px",
    // },
    // labelFontWeight: {
    //   type: String,
    //   default: "700",
    // },
    // labelColor: {
    //   type: String,
    //   default: "",
    // },
    showLabels: {
      type: Boolean,
      default: false,
    },
    selectLabel: {
      type: String,
      default: "",
    },
    deselectLabel: {
      type: String,
      default: "",
    },
  },
  methods: {
    setMultiSelectContainer() {
      this.multiselectContainer = document.querySelector(
        `.vp-multiselect-${this.uniqueKey}`
      );
      this.multiselect = document.querySelector(
        `.multiselect-${this.uniqueKey}`
      );
      this.spinner = document.querySelector(
        `.vp-multiselect-${this.uniqueKey} .wizard-spinner`
      );
      if (this.width) {
        this.multiselectContainer?.style.setProperty(
          "width",
          `${this.width}px`,
          "important"
        );
        this.multiselect?.style.setProperty(
          "width",
          `${this.width}px`,
          "important"
        );
      } else {
        this.multiselectContainer?.style.setProperty(
          "width",
          "416px",
          "important"
        );
        this.multiselect?.style.setProperty("width", "416px", "important");
      }
      this.multiselect?.style.setProperty("display", "block", "important");
      this.multiselectContainer?.style.setProperty(
        "z-index",
        this.zIndex,
        "important"
      );
      if (this.disabled) {
        this.spinner?.style.setProperty("opacity", "0.6", "important");
        this.multiselect?.style.setProperty("opacity", "0.6", "important");
      } else {
        this.spinner?.style.setProperty("opacity", "1", "important");
        this.multiselect?.style.setProperty("opacity", "1", "important");
      }
      this.spinner?.style.setProperty(
        "z-index",
        (+this.zIndex + 1).toString(),
        "important"
      );
    },
    // #Input
    setMutliselectInput() {
      this.multiselect_input = document.querySelector(
        `.multiselect-${this.uniqueKey} .multiselect__input`
      );

      this.multiselect_input?.style.setProperty(
        "font-size",
        "16px",
        "important"
      );
      this.multiselect_input?.style.setProperty("top", "10px", "important");
      this.multiselect_input?.style.setProperty(
        "background",
        this.backgroundColor,
        "important"
      );
    },

    // #Single
    setMutliselectSingle() {
      this.multiselect_single = document.querySelector(
        `.multiselect-${this.uniqueKey} .multiselect__single`
      );

      this.multiselect_single?.style.setProperty(
        "background",
        this.backgroundColor,
        "important"
      );

      let singleSelectWidth = +this.width - 60;
      this.multiselect_single?.style.setProperty(
        "width",
        `${singleSelectWidth}px`,
        "important"
      );

      if (this.title && this.showTitle)
        this.multiselect_single?.style.setProperty("top", "20px", "important");
      else
        this.multiselect_single?.style.setProperty("top", "10px", "important");

      if (this.disabled)
        this.multiselect_single?.style.setProperty(
          "opacity",
          "0.7",
          "important"
        );
      else
        this.multiselect_single?.style.setProperty("opacity", "1", "important");
    },

    // #Placeholder
    setMutliselectPlaceholder() {
      // const multiselect_placeholder = document.querySelector(
      //   `.multiselect-${this.uniqueKey} .multiselect__placeholder`
      // );
      // console.log(multiselect_placeholder);
      // multiselect_placeholder?.style.setProperty(
      //   "padding-bottom",
      //   "30px",
      //   "important"
      // );
    },

    // #Tags
    setMultiselectTags() {
      this.multiselect_tags = document.querySelector(
        `.multiselect-${this.uniqueKey} .multiselect__tags`
      );

      this.multiselect_tags.style.setProperty(
        "height",
        this.height,
        "important"
      );
      this.multiselect_tags?.style.setProperty(
        "background",
        this.backgroundColor,
        "important"
      );

      if (this.showPlaceholderIcon && this.multiple) {
        this.multiselect_tags.style.setProperty("height", "auto", "important");
      }
      if (this.showPlaceholderIcon)
        this.multiselect_tags.style.setProperty(
          "padding-inline-start",
          "35px",
          "important"
        );
      else {
        if (this.multiple) {
          this.multiselect_tags.style.setProperty(
            "padding-top",
            this.value?.length ? "30px" : "7px",
            "important"
          );
        }

        this.multiselect_tags.style.setProperty(
          "padding-inline-start",
          this.multiple && this.value?.length ? "20px" : "7px",
          "important"
        );
      }
    },

    // #ContentWrapper
    setMultiselectContentWrapper() {
      this.multiselect_content_wrapper = document.querySelector(
        `.multiselect-${this.uniqueKey} .multiselect__content-wrapper`
      );
      if (this.multiselect_content_wrapper)
        this.multiselect_content_wrapper.style.setProperty(
          "position",
          this.dropDownStyle,
          "important"
        );
    },
    // #multiselect__select
    setMultiselectSelect() {
      this.multiselect_select = document.querySelector(
        `.multiselect-${this.uniqueKey} .multiselect__select`
      );

      if (this.isLoading)
        this.multiselect_select?.style.setProperty(
          "display",
          "none",
          "important"
        );
      else
        this.multiselect_select?.style.setProperty(
          "display",
          "block",
          "important"
        );
    },
    setMultiselectContentList() {
      this.multiselect_content_list = document.querySelectorAll(
        `.multiselect-${this.uniqueKey} .multiselect__content > li`
      );

      if (this.showOptionsBorder) {
        this.multiselect_content_list.forEach((node) => {
          node.style.setProperty("border-bottom", "1px solid #EBEBEB", "important");
          if(this.options?.length > 4)
            node.style.setProperty("margin-inline-end:", "8px", "important");
        });
      } else {
        this.multiselect_content_list.forEach((node) => {
          node.style.setProperty("border", "none", "important");
        });
      }
    },
    setDisabledState() {
      const multiselect_title = document.querySelector(
        `.vp-multiselect-${this.uniqueKey} .multiselect-title`
      );

      const placeholderIcon = document.querySelector(
        `.vp-multiselect-${this.uniqueKey} .placeholder-icon`
      );

      if (this.disabled) {
        multiselect_title?.style.setProperty("opacity", "0.6", "important");
        placeholderIcon?.style.setProperty("opacity", "0.7", "important");
      } else {
        multiselect_title?.style.setProperty("opacity", "1", "important");
        placeholderIcon?.style.setProperty("opacity", "1", "important");
      }
    },
    toggleLabel() {
      if (!this.multiple) this.showLabel = !this.showLabel;
    },
    dropdownOpened() {
      this.isOpen = true;
      if (this.multiple) {
        this.multiselect_tags.style.setProperty(
          "height",
          this.value?.length ? "auto" : "55px",
          "important"
        );
      }
    },
    dropdownClosed() {
      this.isOpen = false;
      if (this.multiple) {
        this.multiselect_tags.style.setProperty("height", "auto", "important");
      }
    },
    onSearchChange(searchQuery) {
      this.$emit("searchChange", searchQuery);
    },
    onSelect(selectedOption) {
      this.$emit("select", selectedOption);
    },
    handleEmit(value) {
      this.$emit("input", value);
    },
  },
  mounted() {
    this.showLabel = this.showTitle;

    this.setMultiSelectContainer();

    this.setMultiselectTags();

    this.setMutliselectPlaceholder();

    this.setMultiselectContentWrapper();

    this.setMutliselectInput();

    this.setMutliselectSingle();

    this.setMultiselectSelect();

    this.setMultiselectContentList();

    this.setDisabledState();
  },
  updated() {
    if (this.multiple) this.showLabel = this.showTitle;

    this.setMultiSelectContainer();

    this.setMultiselectContentWrapper();

    this.setMutliselectPlaceholder();

    this.setMultiselectTags();

    this.setMutliselectSingle();

    this.setMutliselectInput();

    this.setMultiselectSelect();

    this.setMultiselectContentList();

    this.setDisabledState();
  },
  watch: {
    width() {
      this.setMultiSelectContainer();
      this.setMutliselectSingle();
    },
    backgroundColor() {
      this.multiselect_tags.style.setProperty(
        "background",
        this.backgroundColor,
        "important"
      );

      this.multiselect_single?.style.setProperty(
        "background",
        this.backgroundColor,
        "important"
      );
    },
    showOptionsBorder() {
      this.setMultiselectContentList();
    },
  },
};
</script>

<style scoped>
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}

.error {
  color: #f46a6a;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.25px;
}

.multiselect-error {
  border: 2px solid #f46a6a;
  border-radius: 6px !important;
}
</style>

<style lang="scss">
.top-17 {
  top: 17% !important;
}
.top-5 {
  top: 5% !important;
}
.vue-treeselect__control
  .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
  font-weight: 700 !important;
}
div[class*="vp-multiselect-"] {
  width: 416px !important;

  .multiselect {
    width: 416px !important;
    border-radius: 4px !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 9px;
    // height: 30px !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }
  .multiselect--active {
    z-index: 2 !important;
  }
  span.multiselect__option {
    white-space: break-spaces;
  }
  .error-container {
    margin-top: 8px;
    padding-inline-start: 22px;
  }
  .multiselect__single {
    font-size: 16px !important;
    font-weight: 700 !important;
    inset-inline-start: 16px !important;
    color: #4a4a4a !important;
    height: 18px;
    max-height: 18px;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .multiselect__select:before {
    color: #636161 !important;
    margin-top: 4px;
    border-color: #636161 transparent transparent !important;
  }
  .multiselect__placeholder {
    margin-top: 8px !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-inline-start: 16px !important;
    color: #787878 !important;
  }

  .multiselect__select {
    top: 6px !important;
    z-index: 1;
  }
  .multiselect__tags {
    border: none !important;
  }
  .placeholder-icon {
    position: absolute;
    z-index: 3;
    top: 20px;
    inset-inline-start: 20px;
  }
  .multiselect__content-wrapper {
    z-index: 1 !important;
  }
  .multiselect__input {
    font-weight: 700 !important;
    padding-inline-start: 10px !important;
  }
  .wizard-spinner {
    position: absolute;
    top:15px;
    inset-inline-end:10px;
    z-index: 1;
  }
  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
  .multiselect__content > li {
    .multiselect__option {
      color: #787878 !important;
      font-weight: 400 !important;
      font-size: 16px !important;
    }
    .multiselect__option--highlight {
      color: #ffffff !important;
    }
  }
}
</style>
